import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';

export const Route = createFileRoute('/_authenticated/dashboard/events')({
  // Auth matrix (spec cross-cutting): org_admin and supervisor may manage events;
  // operators cannot. Backend RBAC is the source of truth; this guard blocks
  // direct-URL access from operator and super_admin.
  beforeLoad: () => {
    const session = getCurrentSession();
    if (!session) {
      throw redirect({ to: '/login' });
    }
    const role = session.user.role;
    if (role !== 'org_admin' && role !== 'supervisor') {
      throw redirect({ to: '/dashboard' });
    }
  },
  component: () => <Outlet />,
  staticData: {
    breadcrumb: ['Manage', 'Events'],
  },
});
